import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';

export enum IntegrationProvider {
    Intercom = 'intercom',
    Crisp = 'crisp',
    WhatsApp = 'whatsapp',
}

export interface integrationSetting {
    integrationProvider: IntegrationProvider
    identifier: string
    position?: 'left' | 'right'
}

export interface nullIntegrationSetting {
    integrationProvider: null
    identifier: null
    position?: null
}

export interface updateIntegrationSettingForm {
    integrationProvider: IntegrationProvider
    identifier: string
    identityVerificationSecret: string
    position?: 'left' | 'right'
}

export default (axios: AxiosInstance = baseAxios): { getIntegrationSetting: () => Promise<integrationSetting | nullIntegrationSetting>; updateIntegrationSetting: (form: updateIntegrationSettingForm) => Promise<void>; clearIntegrationSetting: () => Promise<void>; } => ({
    getIntegrationSetting: async (): Promise<integrationSetting | nullIntegrationSetting> => {
        const response = await axios.get<integrationSetting>('/api/staff/settings/customer-support-integration');
        return response.data;
    },

    updateIntegrationSetting: async (form: updateIntegrationSettingForm): Promise<void> => {
        await axios.put('/api/staff/settings/customer-support-integration', {
            integrationProvider: form.integrationProvider,
            identifier: form.identifier,
            identityVerificationSecret: form.identityVerificationSecret,
            position: form.position,
        });
    },

    clearIntegrationSetting: async (): Promise<void> => {
        await axios.delete('/api/staff/settings/customer-support-integration');
    },
});
